import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { Col } from '../../../packages/kiti/components/structure/Grid'
import { useCalendarEvents, useCalendarEventsState } from './_load/CalendarLoader'
import { useFormInitialStateFromFilter } from '../list/_helpers/formStateFromFilter'
import { useOpenEditServiceOrderModal, useOpenServiceOrderModal } from '../../../utils/routes/modals/modalsActions'
import Calendar from '../../../packages/kiti/components/calendar/Calendar'
import CalendarDatePicker from '../../../packages/kiti/components/calendar/CalendarDatePicker'
import CalendarPerspectivePicker from '../../../packages/kiti/components/calendar/CalendarPerspectivePicker'
import ControlBar from '../list/ControlBar'
import LimitWarning from './LimitWarning'

const Content = () => {
  const { date, setDate, loading } = useCalendarEventsState()
  const events = useCalendarEvents()

  const openShowModal = useOpenServiceOrderModal()
  const openEditModal = useOpenEditServiceOrderModal()
  const getState = useFormInitialStateFromFilter()
  const hasAddPermission = useSessionPermission('createServiceOrder')

  let onSelectEmptyTime = undefined
  if (hasAddPermission) {
    onSelectEmptyTime = scheduling => {
      openEditModal({ initialState: { ...getState(), scheduling } })
    }
  }

  return (
    <Calendar
      events={events || []}
      onChangeDate={(_, startAt, endAt) => setDate([startAt.toISOString(), endAt.toISOString()])}
      onSelectEmptyTime={onSelectEmptyTime}
      onSelectEvent={event => openShowModal({ id: event.recordId })}
      hideNavigation
      loading={loading}
    >
      <ControlBar
        selectedScreen="calendar"
        middleContent={<CalendarDatePicker />}
        hideDateFilters
        rightContent={
          <Col align="flex-end" justify="flex-end">
            <CalendarPerspectivePicker />
          </Col>
        }
      />

      <LimitWarning />
    </Calendar>
  )
}

export default Content
